export default "__VITE_ASSET__3f7fe6f7__"